
import Vue from 'vue'
import NavigationTab from '@/components/shared/NavigationTab.vue'
import { myRegistrationApi } from '@/api/auth/myHorseRegistration'

export default Vue.extend({
  name: 'RegistrationRoot',
  components: {
    NavigationTab,
  },
  data: () => ({
    consignmentCount: 0,
  }),
  methods: {
    async updateTabs() {
      this.consignmentCount = await myRegistrationApi.countByConsigner()
    },
  },
  computed: {
    items(): {path: string, icon?: string, title: string, counter?: number}[] {
      const res: {path: string, icon?: string, title: string, counter?: number}[] = [
        {
          path: 'nouveau',
          icon: 'mdi-alert-decagram',
          title: 'title.new-registrations',
        },
        {
          path: 'recapitulatif',
          icon: 'mdi-list-status',
          title: 'title.recap',
        },
        {
          path: 'historique',
          icon: 'mdi-history',
          title: 'title.old-registrations',
        },
      ]
      if (this.consignmentCount > 0) {
        res.push({
          path: 'consignment',
          icon: 'mdi-offer',
          title: 'title.consignment',
          counter: this.consignmentCount,
        })
      }
      return res
    },
  },
  async mounted() {
    this.updateTabs()
  },
})
